// @flow

import _ from 'lodash';

import { utils as serviceUtils } from '@zapier/services';
import { toLowerCaseString } from '@zapier/common-utils';

import type { FlattenedState } from '@zapier/editor/src/types';
import type { Service } from '@zapier/services';

type Params = {
  query?: FlattenedState,
  services: Service[],
};

const generateZapTitleFromActions = ({ query, services }: Params) => {
  if (
    !query ||
    !query.headActionLabel ||
    !query.tailActionLabel ||
    _.isEmpty(services)
  ) {
    return '';
  }

  const {
    headServiceId,
    headActionLabel,
    tailServiceId,
    tailActionLabel,
  } = query;

  const headActionAppName =
    (serviceUtils.getServiceByKey(services, headServiceId) || {}).name || '';
  const tailActionAppName =
    (serviceUtils.getServiceByKey(services, tailServiceId) || {}).name || '';

  // When trigger and action apps are the same
  if (headServiceId === tailServiceId) {
    return `${_.upperFirst(
      toLowerCaseString(tailActionLabel)
    )} in ${headActionAppName} when ${toLowerCaseString(headActionLabel)}`;
  }

  // When trigger and action apps are different
  return `${_.upperFirst(
    toLowerCaseString(tailActionLabel)
  )} in ${tailActionAppName} when ${toLowerCaseString(
    headActionLabel
  )} in ${headActionAppName}`;
};

export default generateZapTitleFromActions;
